import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@card-software/library';
import { environment } from '@environments/environment';
import { SigningSession, SigningSessionEvent } from '@app/models/signing-session/signing-session';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SigningSessionProxyService {
  private baseUrl = `${environment.proxyUrls.userMasterApi}/api/v1/signing-session`;

  constructor(private httpClient: HttpClient) {}

  open(): Observable<ApiResponse<SigningSession>> {
    return this.httpClient.post<ApiResponse<SigningSession>>(this.baseUrl, {});
  }

  getCurrent(): Observable<ApiResponse<SigningSession>> {
    return this.httpClient.get<ApiResponse<SigningSession>>(`${this.baseUrl}/current`);
  }

  getById(id: string): Observable<ApiResponse<SigningSession>> {
    return this.httpClient.get<ApiResponse<SigningSession>>(`${this.baseUrl}/${id}`);
  }

  getHistory(limit = 50): Observable<ApiResponse<SigningSession[]>> {
    return this.httpClient.get<ApiResponse<SigningSession[]>>(`${this.baseUrl}/history`, { params: { limit } });
  }

  verifyOtp(id: string, code: string): Observable<ApiResponse<SigningSession>> {
    return this.httpClient.post<ApiResponse<SigningSession>>(`${this.baseUrl}/${id}/otp/verify`, { code });
  }

  close(id: string): Observable<ApiResponse<SigningSession>> {
    return this.httpClient.post<ApiResponse<SigningSession>>(`${this.baseUrl}/${id}/close`, {});
  }

  getEvents(id: string): Observable<ApiResponse<SigningSessionEvent[]>> {
    return this.httpClient.get<ApiResponse<SigningSessionEvent[]>>(`${this.baseUrl}/${id}/events`);
  }
}
